/**
 * Status chip for a sub-delegate entry (active relationship or pending
 * invitation, with an expired variant for stale invites).
 */

import { CheckCircle2, Clock, AlertTriangle } from 'lucide-react';
import type { DelegateStatus } from './types';

const STATUS_STYLES: Record<DelegateStatus, { label: string; className: string; Icon: typeof Clock }> = {
  ACTIVE: {
    label: 'Active',
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    Icon: CheckCircle2,
  },
  PENDING: {
    label: 'Pending',
    className: 'bg-amber-50 text-amber-700 border-amber-200',
    Icon: Clock,
  },
  EXPIRED: {
    label: 'Expired',
    className: 'bg-red-50 text-red-700 border-red-200',
    Icon: AlertTriangle,
  },
};

type DelegateStatusBadgeProps = {
  status: DelegateStatus;
};

export function DelegateStatusBadge({ status }: DelegateStatusBadgeProps) {
  const { label, className, Icon } = STATUS_STYLES[status];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${className}`}
      data-testid={`delegate-status-${status}`}
    >
      <Icon className="h-3 w-3" aria-hidden="true" />
      {label}
    </span>
  );
}
